import type { SVGProps } from "react";
export interface AgeLimit12IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function AgeLimit12Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: AgeLimit12IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12C.875 5.857 5.856.876 12.001.876q.75 0 1.476.097l.48.074.113.027a1.126 1.126 0 0 1-.392 2.203l-.115-.013-.382-.06a8.876 8.876 0 1 0 7.557 7.233l1.108-.196 1.107-.198a11 11 0 0 1 .172 1.959c0 6.143-4.98 11.123-11.124 11.124C5.856 23.125.875 18.145.875 12m20.774-2.868a1.124 1.124 0 0 1 1.304.91l-2.215.394c-.108-.612.3-1.195.911-1.304"
      />
      <path
        fill={color}
        d="M7.625 16v-5.007c-.193.057-.392.1-.598.118l-.293.013H6.5a1.125 1.125 0 0 1 0-2.25h.234l.162-.014a.875.875 0 0 0 .707-.752l.03-.247A1.126 1.126 0 0 1 9.876 8v8a1.125 1.125 0 0 1-2.25 0Zm7.75-5.7v-.05c0-.61-.505-1.125-1.124-1.125-.56 0-1.053.384-1.181.78a1.125 1.125 0 0 1-2.14-.698c.458-1.408 1.88-2.332 3.32-2.332 1.88 0 3.375 1.54 3.375 3.375v.05c0 1.051-.463 1.818-1.084 2.365-.564.498-1.28.83-1.816 1.08-.606.283-1.02.478-1.308.715-.179.147-.255.267-.28.414H16.5l.115.006a1.126 1.126 0 0 1 0 2.239l-.114.006h-4.252a1.374 1.374 0 0 1-1.373-1.374V15c0-1.038.496-1.773 1.113-2.28.555-.457 1.268-.773 1.785-1.015.59-.275 1-.481 1.28-.728.222-.197.322-.38.322-.678Zm3-3.3V5.625H17a1.125 1.125 0 0 1 0-2.25h1.375V2a1.125 1.125 0 0 1 2.25 0v1.375H22a1.125 1.125 0 0 1 0 2.25h-1.375V7a1.125 1.125 0 0 1-2.25 0"
      />
    </svg>
  );
}
